import ArrowDownward from "@mui/icons-material/ArrowDownward";
import { colors } from "healthex-common/colors";
import styled, { css, keyframes } from "styled-components";
import { FlexColumn, FlexColumnDiv, FlexRow, HorizontalDivider } from "./common.styles";
import { HXMobileButton } from "./HXButton";
import { HXMobilePageTitleText, LightText, LittleText, mobilePageHPadding } from "./HXMobilePage.styles";
import { Parent as HXMobilePageParent, HXMobilePageWithFixedHeaderAndFooterContent, TinyText } from "./HXMobilePage.styles";
import { fontSizes } from "healthex-common/sizes";
import { createFadeInAnimation } from "./animations.styles";
import Security from "@mui/icons-material/Security";
import Description from "@mui/icons-material/Description";
import CheckCircle from "@mui/icons-material/CheckCircle";
import { fontWeights } from "healthex-common/weights";
import { LongPressButton } from "./LongPressButton";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ErrorIcon from "@mui/icons-material/Error";
import React from "react";
import clearLogoLight from "../Media/clear-logo-light.svg";
export const patientConsentStepParentId = "patientConsentStepParent";
export const PageWithFixedHeaderAndFooterContent = styled(HXMobilePageWithFixedHeaderAndFooterContent).attrs({
    id: patientConsentStepParentId,
}) ``;
export const PatientConsentParent = styled(HXMobilePageParent) `
    margin-top: ${(props) => { var _a; return (_a = props.marginTop) !== null && _a !== void 0 ? _a : 16; }}px;
`;
export const Title = styled(HXMobilePageTitleText) `
    font-size: ${fontSizes.SUPER};
    line-height: 100%;
`;
export const TitlePreWrap = styled(Title) `
    white-space: pre-wrap;
`;
export const FooterText = styled(TinyText) `
    color: ${colors.black_light};
    align-self: stretch;
    text-align: center;
    padding: 6px 0;
    white-space: pre-wrap;
    font-size: ${fontSizes.MICRO};
`;
export const FooterTextLink = styled.a `
    color: ${colors.black_lighter};
    text-decoration: underline;
    cursor: pointer;

    &:hover {
        color: ${colors.black_main};
    }
`;
export const FooterErrorText = styled(FooterText) `
    color: ${colors.tulip_main};
    align-self: stretch;
`;
export const AccentedBackground = styled(FlexColumnDiv) `
    background-color: ${colors.accents_sunset_12};
    padding: 12px;
    border-radius: 12px;
    gap: 24px;
    align-self: stretch;
    word-wrap: break-word;
`;
export const AccentedInfoBackground = styled(FlexColumnDiv) `
    background-color: ${colors.navy_8};
    padding: 8px;
    border-radius: 4px;
    gap: 24px;
    align-self: stretch;
    word-wrap: break-word;
`;
export const AccentedBackgroundIcon = styled.img `
    width: 20px;
    height: 20px;
`;
export const FooterContainer = styled(FlexColumnDiv) `
    padding: 24px ${mobilePageHPadding}px;
    align-items: center;
    align-self: stretch;
    gap: 18px;
    animation: ${(props) => (props.animate ? createFadeInAnimation(0, 1) : "none")} 500ms linear 500ms both;
`;
export const BaseButton = styled(HXMobileButton) `
    width: 100%;
    line-height: normal;
`;
export const LongPressBaseButton = styled(LongPressButton) `
    width: 100%;
    line-height: normal;
`;
export const ConfirmButton = styled(BaseButton).attrs({ variant: "contained" }) ``;
const ClearLogoLightIcon = styled.img.attrs({ src: clearLogoLight, width: 24, height: 24 }) ``;
export const ConfirmWithClearButton = styled(ConfirmButton).attrs({ startIcon: React.createElement(ClearLogoLightIcon) }) `
    background-color: ${colors.clear_button_background};

    @media (hover: hover) {
        &:hover {
            background-color: ${colors.clear_button_hover};
        }
    }
`;
export const LongPressConfirmButton = styled(LongPressBaseButton).attrs({ variant: "contained" }) ``;
export const ClearLongPressConfirmButton = styled(LongPressBaseButton) ``;
export const SecondaryButton = styled(BaseButton) ``;
export const TextButton = styled(BaseButton).attrs({ variant: "text" }) ``;
export const PrivacyButton = styled(TextButton) ``;
export const FooterPlaceholderButton = styled(BaseButton).attrs({ children: "Placeholder button for spacing does nothing" }) `
    pointer-events: none;
    opacity: 0;
`;
export const ArrowDownwardIcon = styled(ArrowDownward) `
    height: 32px;
    width: 32px;
    background-color: ${colors.sunset_main};
    border-radius: 100%;
    z-index: 1;
`;
export const ArrowDownDividerContainer = styled(FlexColumn) `
    position: relative;
    height: 32px;
    align-items: center;
    color: ${colors.white_main};
`;
export const ArrowDownHorizontalDivider = styled(HorizontalDivider) `
    position: absolute;
    z-index: 0;
    height: 1px;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto 0;
`;
export const TextContainer = styled(FlexColumnDiv) `
    padding: 0;
    align-items: flex-start;
    gap: 4px;
`;
export const ImageContainer = styled(FlexColumn) `
    text-align: flex-start;
    gap: 16px;
`;
export const SegmentImageContainer = styled(FlexColumn) `
    height: 160px;
    border: 1px solid ${colors.black_12};
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: ${colors.white_main};

    &:hover {
        background: linear-gradient(0deg, #07142014 0%, #07142014 100%);
    }
`;
export const SegmentImage = styled.img `
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    width: auto;
    height: auto;
`;
export const ImageCaption = styled(TinyText) ``;
const fadeIn = keyframes `
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;
export const SuccessContainer = styled(FlexColumn) `
    gap: 16px;
    padding: 0 12px;
    align-items: flex-start;
    width: 100%;
    box-sizing: border-box;

    /* Initial state: always hidden, only animation controls visibility */
    ${(props) => props.animate &&
    css `
            opacity: 0;
        `}

    /* Animation: fade in after heading moves */
    ${(props) => !props.isAnimating &&
    props.animate &&
    css `
            animation: ${fadeIn} 300ms ease-in forwards;
            animation-delay: 400ms;
        `}
`;
export const SuccessRow = styled(FlexRow) `
    align-items: center;
    justify-content: flex-start;
    gap: 16px;
    text-align: left;
`;
export const SettingsIconWrapper = styled(FlexColumn) `
    height: 48px;
    width: 48px;
    border-radius: 50%;
    background-color: ${colors.blue_10};
    opacity: 0.7;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;

    svg {
        width: 20px;
        height: 20px;
    }
`;
export const ConfirmationText = styled(LightText) `
    align-items: flex-start;
    font-size: 13px;
    font-weight: 400;
`;
export const BasePDDEGDUIcon = css `
    width: 20px;
    height: 20px;
    color: ${colors.navy_main};
    opacity: 0.7;
`;
export const SecurityIcon = styled(Security) `
    ${BasePDDEGDUIcon}
`;
export const DescriptionIcon = styled(Description) `
    ${BasePDDEGDUIcon}
`;
export const CheckCircleIcon = styled(CheckCircle) `
    ${BasePDDEGDUIcon}
`;
export const ErrorText = styled.div `
    font-size: ${fontSizes.LITTLE};
    font-weight: ${fontWeights.NORMAL};
    color: ${colors.navy_main};
`;
export const ErrorTextBold = styled.div `
    font-size: ${fontSizes.LITTLE};
    font-weight: ${fontWeights.BOLD};
    color: ${colors.navy_main};
    display: inline;
`;
export const ConfirmButtonWithClearLongPress = styled(LongPressConfirmButton) `
    ${(props) => !props.isPatientLoggedIn &&
    css `
            background-color: ${colors.clear_button_background};

            @media (hover: hover) {
                &:hover {
                    background-color: ${colors.clear_button_hover};
                }
            }
        `}
`;
export const BlueHorizontalDivider = styled(HorizontalDivider) `
    border-color: ${colors.blue_10};
`;
const PatientConsentBaseLeftButtonIcon = css `
    color: ${colors.navy_main};
    width: 24px;
    height: 24px;
    padding: 12px 20px 12px 4px;
    cursor: pointer;
`;
export const PatientConsentInfoOutlinedIcon = styled(InfoOutlinedIcon) `
    ${PatientConsentBaseLeftButtonIcon}
`;
export const PatientConsentOpenInNewOutlinedIcon = styled(OpenInNewOutlinedIcon) `
    ${PatientConsentBaseLeftButtonIcon}
`;
export const PatientConsentErrorIcon = styled(ErrorIcon) `
    ${PatientConsentBaseLeftButtonIcon}
    color: ${colors.blue_main};
`;
export const FirstFeaturedGap = styled.div `
    width: 100%;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 12px;
    height: 16px;
    display: inline-flex;
`;
export const FirstFeaturedGapDivider = styled.div `
    flex: 1 1 0;
    height: 16px;
    justify-content: flex-start;
    align-items: center;
    gap: 16px;
    display: flex;
`;
export const FirstFeaturedGapDividerLine = styled.div `
    flex: 1 1 0;
    height: 0px;
    outline: 1px rgba(29, 98, 174, 0.1) solid;
    outline-offset: -0.5px;
`;
export const FirstFeaturedGapText = styled(TinyText) `
    text-align: center;
`;
export const IdpHintMessage = styled(LittleText) `
    text-align: center;
    padding: 0 46px;
`;
